import type { BlogDto } from '@gr/core/accounts/workspaces/dto';
import { DEFAULT_TIMEZONE } from '@gr/core/time/zoned-time';

/** Значения формы блога: создание (WS-UC-1) и настройки (WS-UC-3). */
export interface BlogValues {
  name: string;
  description: string;
  timezone: string;
}

export const BLOG_FORM_FIELDS = ['name', 'description', 'timezone'] as const;

export function newBlogValues(): BlogValues {
  return { name: '', description: '', timezone: DEFAULT_TIMEZONE };
}

export function blogValuesOf(blog: Pick<BlogDto, 'name' | 'description' | 'timezone'>): BlogValues {
  return { name: blog.name, description: blog.description, timezone: blog.timezone };
}
